import React from "react";
import { styled } from "styled-components";
import { Text } from "../../TextConstants";

const AquaContact = ({ contact }) => {
  return (
    <ContactValueWrapper>
      <ContactLabel>{Text.contact}</ContactLabel>
      <ContactValue>
        <span>{contact}</span>
      </ContactValue>
    </ContactValueWrapper>
  );
};

const ContactLabel = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
`;

const ContactValue = styled.div`
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  // justify-content: space-between;
  // width: 100%;
`;

const ContactValueWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export default AquaContact;
